import { Component, OnInit } from '@angular/core';
import { FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { JSIGNALBUTTON } from 'src/app/shared/common/JsignalButtons';
import { validationmethod } from 'src/app/shared/common/validationmethod';
import { LifecycleService } from 'src/app/shared/services/lifecycle.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { WorkFlowPopUpComponent } from './work-flow-pop-up/work-flow-pop-up.component';

@Component({
    selector: 'app-work-flow',
    templateUrl: './work-flow.component.html',
    styleUrls: ['./work-flow.component.scss'],
    standalone: false
})
export class WorkFlowComponent implements OnInit {

   validation_messages
  // columnDefs;
  rowClassRules;
  defaultColDef;
  rowSelectionForTablesFields;
  rowSelection;
  
  paginationPageSize;
  
  paginationNumberFormatter;
  
  lastpage;
  
  currentpage;
  
  nextpage;
  
  nextpageplusone;
  
  totalpages;
  
  buttonIdList: any = [];
  pagesize;
  components: any;
  gridApi;
    backgroundColorScreen: any;
    buttonColor: any;
    rowData: any[] = [
      // { id: 1, name: "Item 1", status: "Yes" },
      // { id: 2, name: "Item 2", status: "No" },
      // { id: 3, name: "Item 3", status: "Yes" },
    ];
    columnDefs = [
      { headerName: "Action", field: "action", sortable: true, filter: true,width: 100 },
      { headerName: "State Name", field: "statename", sortable: true, filter: true,width: 200 },
      { headerName: "State Type", field: "statetype", sortable: true, filter: true,width: 150 }
    ];
    buttonName
    lifecycleStatesrequestDto = {
      statename: "",
      statetype:""
    }
    lifecycleRequestDto = {
    lifecyclename: "",
      description: "",
      object: "",
      states: [] as any[]
    }
    objects = [
      { value: "Object1", viewValue: "Object 1" },
      { value: "Object2", viewValue: "Object 2" },
      { value: "Object3", viewValue: "Object 3" }
    ];
     validations_form: UntypedFormGroup;
    formValid: UntypedFormGroup;
    getRowStyle: (params: any) => { backgroundColor: string; };
    columnDefinitionsForLifecycle = []
    frameworkcomponent;
    getData: any;
    selectedWorkflow: any = null;
    showWorkflowForm = false;
    constructor(private localStorageSettings: LocalStorageSettingsService, private validation: validationmethod,
      private spinner: NgxUiLoaderService, private snackbar: MatSnackBar,private dialog:MatDialog, private lifecycleservice: LifecycleService
    ) {
      this.components = {
        buttonRenderer: JSIGNALBUTTON
      }
    }
   
    ngOnInit(): void {
      this.buttonName = 'Save'
      this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
        resizable: true,
        filter: true,
        sortable: true,
      }
      this.columnDefinitionsForLifecycle = [{
         headerName: 'Action', filter: false, cellRenderer: 'buttonRenderer',
        pinned:'left',
        lockPinned:true,
        cellRendererParams: {
          values:this.buttonIdList,
          edit: this.editIcon.bind(this),
          delete: this.deleteIcon.bind(this),
        }, width: 150
      },
      { headerName: 'Workflow Name', headerTooltip: 'Workflow Name', tooltipValueGetter: (params) => 'Workflow Name : ' + params.value, field: 'workflowname', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Description', headerTooltip: 'Description', tooltipValueGetter: (params) => 'Description : ' + params.value, field: 'description', filter: 'agTextColumnFilter', width: 250 },
      // { headerName: 'Object', headerTooltip: 'Object', tooltipValueGetter: (params) => 'Object : ' + params.value, field: 'objectname', filter: 'agTextColumnFilter', width: 350 },  
        { headerName: 'Lifecycle', headerTooltip: 'Lifecycle', tooltipValueGetter: (params) => 'Lifecycle : ' + params.value, field: 'lifecycleName', filter: 'agTextColumnFilter', width: 250 },
        // { headerName: 'States', headerTooltip: 'States', tooltipValueGetter: (params) => 'States : ' + params.value, field: 'states', filter: 'agTextColumnFilter', width: 350 },
        //  {headerName: "Start State",headerTooltip: "Start State",field: "start",cellRenderer: (params) => {return params.value?.map(s => s.statename).join(", ");}, tooltipValueGetter: (params) => {return params.value?.map(s => s.statename).join(", ");}, filter: 'agTextColumnFilter', width: 250 },
        { headerName: 'Start State', headerTooltip: 'Start State', tooltipValueGetter: (params) => 'Start State : ' + params.value, field: 'startingStates', filter: 'agTextColumnFilter', width: 250 },
      
        {
          headerName: 'Status', headerTooltip: 'Status', tooltipValueGetter: (params) => 'Status : ' + params.value, field: 'status', filter: 'agTextColumnFilter', width: 350,
          cellStyle: (params) => {
            if (params.value == 'Yes'){
              return { color: 'green' };
            } else {
              return { color: 'red' };
            }
          },
        }
        
      ]
      this.formValidation();
      this.formValidationforState();
      this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
      this.buttonColor = this.localStorageSettings.getSettings("ColorA");
  
    }
    formValidation() {
      this.validations_form = new UntypedFormGroup({
        lifecyclename: new FormControl('', [Validators.required, this.validation.specialCharacterValidator, this.validation.noWhitespaceValidator]),
        description: new FormControl('', [Validators.required, this.validation.specialCharacterValidator, this.validation.noWhitespaceValidator]),
        object: new FormControl(''),
      });
    }
    formValidationforState() {
      this.formValid = new UntypedFormGroup({
        statename: new FormControl('',),
        statetype: new FormControl('', ),
      });
    } 
  
    
    onBtExport() {
      this.gridApi.api.exportDataAsCsv();
    }
  
    //pagination code
    onPaginationChanged() {
      if (this.gridApi.api) {
        this.lastpage = this.gridApi.api.paginationIsLastPageFound();
        this.currentpage = this.gridApi.api.paginationGetCurrentPage() + 1
        this.nextpage = this.gridApi.api.paginationGetCurrentPage() + 1 + 1
        this.nextpageplusone = this.gridApi.api.paginationGetCurrentPage() + 1 + 1 + 1
        this.totalpages = this.gridApi.api.paginationGetTotalPages()
      }
    }
    //this function is for going to the given page number 
    onSearchChange(searchValue: number) {
  
      this.gridApi.api.paginationGoToPage(searchValue - 1);
    }
  
    // below function is for changing the no of rows per page
    onPageSizeChanged() {
      var value = this.pagesize
      this.gridApi.api.setGridOption('paginationPageSize', Number(value));
    }
  
    // below function is for going to next page
    onBtNext() {
      console.log("next")
      this.gridApi.api.paginationGoToNextPage();
    }
  
    // below function for going to previous page
    onBtPrevious() {
      console.log("previous")
      this.gridApi.api.paginationGoToPreviousPage();
    }
  
    // below function for going to first page
    onBtFirst() {
      console.log("first")
      this.gridApi.api.paginationGoToFirstPage();
    }
  
    // below function for going to last page
    onBtLast() {
      console.log("last")
      this.gridApi.api.paginationGoToLastPage();
    }
    onGridReady(params){
      this.gridApi = params;
      params.api.setGridOption('rowData', [])
      
      var tenantId = localStorage.getItem('dnsName');
      console.log(tenantId)
      this.lifecycleservice.getWorkflows().subscribe((response) => { 
        console.log(response)
        if(response.error == true){
          this.snackbar.open(response.statusMessage, 'OK', { duration: 3000 });
          this.getData = null;
          this.gridApi.api.setGridOption('rowData', this.getData);
        } else {
          console.log(response)
         this.getData = response;
        this.gridApi.api.setGridOption('rowData', this.getData);
        }
        
      } )  
       
    }
  
    // editIcon(params) { 
    //   console.log(params.rowData)
    //    this.buttonName = 'Update'
    //   const dialogRef = this.dialog.open(WorkFlowPopUpComponent, {
    //    width: "70%",
    //       autoFocus: false,
    //       maxWidth: '100vw',
    //       height: "85%",
    //     disableClose: true,
    //       data:{edata:params.rowData,buttonName:this.buttonName}
    //   });
    //   dialogRef.afterClosed().subscribe(result => {
    //     console.log('The dialog was closed',result);
    //     this.onGridReady(this.gridApi);
    //   });
  
    // }
  
    deleteIcon(params) {
      console.log(params.rowData)
      if (confirm("Are you sure you want to delete this record?")) {
        this.spinner.start();
        this.lifecycleservice.deleteWorkflow(params.rowData.workflowid).subscribe((response) => {
          console.log(response)
          this.spinner.stop();
          if (response.error == true) {
            this.snackbar.open(response.statusMessage, 'OK', { duration: 3000 });
          } else {
            this.snackbar.open(response.statusMessage, 'OK', { duration: 3000 });
            this.onGridReady(this.gridApi);
          }
         
        })
      } 
    }
  
    // openSaveForm(params) {
    //   this.buttonName = 'Save'
    //   const dialogRef = this.dialog.open(WorkFlowPopUpComponent, {
    //    width: "50%",
    //       autoFocus: false,
    //       maxWidth: '100vw',
    //       height: "85%",
    //       disableClose: true,
    //   });
    //   dialogRef.afterClosed().subscribe(result => {
    //     console.log('The dialog was closed');
    //     this.onGridReady(this.gridApi);
    //   });
    // }


     openSaveForm(type: string) {
      console.log("Inside of openSaveForm");
      this.buttonName = 'Save';
      this.selectedWorkflow = null;
      this.showWorkflowForm = true;
    }

    closeWorkflowForm() {
    this.showWorkflowForm = false;
    }

  editIcon(params) {
    console.log(params.rowData)
    this.buttonName = 'Update';
    this.selectedWorkflow = params.rowData;

    this.showWorkflowForm = true;
  }
  handleBackToWorkFlowMainPage() {
    this.showWorkflowForm = false
  }
  
}
